import React, { useEffect, useState } from "react";
import { Box, Typography, Tabs, Tab, CircularProgress } from "@mui/material";
import FaqList from "./FaqList";
import FaqModal from "./FaqModal";
import BulkUpload from "./BulkUpload";
import ConfirmationModal from "./ConfirmationModal";
import { useAdminFaqsListQuery } from "../../../Services/faqs/FAQs";
import { toast } from "react-toastify";

const Faq = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [faqs, setFaqs] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  // API hooks - Only fetching data
  const {
    data: allFaqsData,
    isLoading: isFaqsLoading,
    refetch: refetchFaqs,
  } = useAdminFaqsListQuery({
    page,
    page_size: pageSize,
  });

  // Initialize FAQs from API
  useEffect(() => {
    if (allFaqsData && Array.isArray(allFaqsData?.results)) {
      const mappedFaqs = allFaqsData?.results?.map((faq) => ({
        id: faq?.id,
        question: faq?.question,
        answer: faq?.answer,
        order: faq?.order,
      }));
      setFaqs(mappedFaqs);
      setTotalCount(allFaqsData?.count || 0);
    } else {
      setFaqs([]);
      setTotalCount(0);
    }
  }, [allFaqsData]);

  // Handle pagination change
  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handlePageSizeChange = (newPageSize: number) => {
    setPageSize(newPageSize);
    setPage(1); // Reset to first page when page size changes
  };

  return (
    <Box
      sx={{
        height: "100vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        // bgcolor: "#fef5f1",
        fontFamily: "Karbon",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          bgcolor: "#fff",
          px: 4,
          py: 3,
          borderBottom: "1px solid #f0e5e0",
        }}
      >
        <Typography variant="h5" color="#666666" fontFamily="Karbon">
          FAQ Management
        </Typography>
      </Box>

      {/* Tabs */}
      <Box sx={{ bgcolor: "#fff", borderBottom: "1px solid #f0e5e0" }}>
        <Tabs
          value={activeTab}
          onChange={(e, newValue) => setActiveTab(newValue)}
          sx={{
            px: 4,
            "& .MuiTab-root": {
              color: "#666666",
              fontWeight: 500,
              textTransform: "none",
              fontSize: "1rem",
              minHeight: 56,
              fontFamily: "Karbon",
            },
            "& .Mui-selected": {
              color: "#ff6b35 !important",
            },
            "& .MuiTabs-indicator": {
              backgroundColor: "#ff6b35",
              height: 3,
            },
          }}
        >
          <Tab label="FAQ List" />
          <Tab label="Bulk Upload" />
        </Tabs>
      </Box>

      {/* Loading Overlay - Only for initial data fetch */}
      {isFaqsLoading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "rgba(0,0,0,0.3)",
            zIndex: 9999,
          }}
        >
          <CircularProgress sx={{ color: "#ff6b35" }} />
        </Box>
      )}

      {/* Content Area */}
      <Box sx={{ flex: 1, overflow: "auto" }}>
        {activeTab === 0 && (
          <FaqList
            faqs={faqs}
            refetchFaqs={refetchFaqs}
            page={page}
            pageSize={pageSize}
            totalCount={totalCount}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
          />
        )}

        {activeTab === 1 && (
          <BulkUpload faqs={faqs} refetchFaqs={refetchFaqs} />
        )}
      </Box>
    </Box>
  );
};

export default Faq;
